import {useTranslation} from "ni18n";
import React, {useMemo} from "react";
import {getAllowedLocationsToRender} from "src/constants/locations";
import {useTypedSelector} from "src/store";

import Layout from "../../components/v5/Layout";
import LocationMapForLocations from "../../components/v5/LocationMapForLocations";
import {RegionSlug} from "../../store/types";
import {useUserSelectedLocation} from "../../utils/browser-storage/userSelectedLocation";

type Props = {
  regionSlug?: RegionSlug;
  state?: string;
  city?: string;
  isNearMe?: boolean;
};

const LocationsIndex = ({regionSlug, isNearMe}: Props) => {
  const i18n = useTranslation();
  const locations = useTypedSelector(state => state.config.locations);
  const {regionSlug: selectedRegionSlugFromLocalStorage = "sf-bay-area"} =
    useUserSelectedLocation();
  const renderableLocations = useMemo(() => getAllowedLocationsToRender(locations), [locations]);

  const pageTitle = i18n.t("Find a Carbon Health Urgent Care & Primary Care Provider Near You");
  const pageDescription = i18n.t(
    "Find an Adult or Pediatric Urgent Care or Primary Care provider near you. Book online for the fastest experience but walk-ins are always welcome.",
  );
  const selectedRegionSlug = useMemo(
    () => regionSlug || selectedRegionSlugFromLocalStorage,
    [regionSlug, selectedRegionSlugFromLocalStorage],
  );

  return (
    <Layout
      pageTitle={pageTitle}
      pageDescription={pageDescription}
      pageImage="location-search"
      pageImageExt="gif"
      ogAlt={i18n.t("Find a Carbon Health location near you.")}
      navStartTransparent={false}
    >
      <LocationMapForLocations
        locations={renderableLocations}
        regionSlug={selectedRegionSlug}
        isNearMe={isNearMe}
      />
    </Layout>
  );
};

export default LocationsIndex;
